<ol>
    <li>Add A button which says 'Display Details'</li>
    <li>Add a paragraph with any content of your choice (e.g. 'Secret Password = tuna')</li>
    <li>Toggle the displaying of that paragraph with the button created in the first step</li>
    <li>Log all button clicks in an array and output that array below the secret paragraph (maybe log a timestamp or simply an incrementing number)</li>
    <li>Starting at the 5th log item, give all future log items a blue background (via ngStyle) and white color (ngClass)</li>
</ol>

<button (click)="onClickButton()">Display details</button>
<p *ngIf="switch; else elseBlock">username = tanocom</p>
<ng-template #elseBlock>
    <p>&nbsp;</p>
</ng-template>
<p
*ngFor="let clickEvent of events; let i = index"
[ngClass]="{underline: i > 4}"
[ngStyle]="{backgroundColor: i > 4 ? 'blue' : 'transparent'}">
    {{clickEvent}}
</p>